import { useEffect } from "react";
import { useFormDispatch } from "../../FormContext.jsx";
import { SingleLine } from "../SingleLine.jsx";
import styles from "../../showroomForm.css";

const DispatchingSingleLine = ({
  fieldKey,
  formData,
  required,
  setFormData,
  error,
  label,
  description,
  validate,
}) => {
  const dispatch = useFormDispatch();
  const value = formData[fieldKey];

  useEffect(() => {
    if (error) return;
    dispatch({ type: "updateField", [fieldKey]: value });
  }, [value, fieldKey, dispatch, error]);

  return (
    <div className={styles.enhancedCompContainer}>
      <SingleLine
        validate={validate}
        label={label}
        fieldKey={fieldKey}
        formData={formData}
        required={required}
        setFormData={setFormData}
        description={description}
        error={error}
      />
    </div>
  );
};

export default DispatchingSingleLine;
